import React from 'react';

const MinusIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M19 13H5v-2h14z" />
  </svg>
);

export default MinusIcon;
